import Navbar from "@/components/public/Navbar";
import Footer from "@/components/public/Footer";

export default function PublicShell({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
        </div>
    );
}
